interface TableSkeletonProps {
  rows?: number;
}

export const TableSkeleton = ({ rows = 5 }: TableSkeletonProps) => {
  return (
    <div className="space-y-3">
      {Array.from(Array(rows).keys()).map((item) => (
        <div key={item} className="h-8 animate-pulse rounded bg-neutral-300" />
      ))}
    </div>
  );
};
